import DepartureScheduleService from "@services/departure-schedule-service";
import { DepartureScheduleQueryParams } from "@interfaces/departure-schedule";
import { setDepartureSchedule } from "@store/departure-schedule-store";

import { departureScheduleQueryKeys } from "./queryKeys";
import { useQuery } from "react-query";

export const useDepartureScheduleQuery = (params?: DepartureScheduleQueryParams) => {
  return useQuery(
    departureScheduleQueryKeys.allDepartureSchedule(params),
    async () => await DepartureScheduleService.getAll(params, (err, resp) => {
      if(err){
        return [];
      }
      setDepartureSchedule(resp?.data!)
    }),
    {
      // enabled: !isGeneral,
      keepPreviousData: true,
    }
  );
};
